/*

Pixel Field Editor - developed by Satori, s.r.o. (c) 2014-2015 - zden@satori.sk
---------------------------------
Legal notice: Source code is for internal purposes only of developing
and integrating Pixel Field Editor to the larger asset of Forms+Surfaces
online services. Any modifications must be discussed with Satori, s.r.o. and no derivates to other projects are allowed without prior written permission from Satori, s.r.o.
---------------------------------
Satori, s.r.o. | Jegeho 21 | 821 08 Bratislava | +421-903-258-862 | www.satori.sk

*/

var FILL = 1;
var OUTLINE = 2;
var MASK = 127;
var GRAD = 128;

FONT_ARIAL_15 = "15px Arial";
var PI = 3.1415926;

function rect(context_in, x1, y1, wid, hei, style, col, alfa)
{
	context_in.beginPath();
	context_in.globalAlpha = alfa;
	context_in.rect(x1, y1, wid, hei);

	switch (style)
	{
		case FILL:
			context_in.fillStyle = col.str;
			context_in.fill(); 
			break;

		case OUTLINE:
			context_in.lineWidth = 1;
			context_in.strokeStyle = col.str;
			context_in.stroke(); 
			break;
	}
}

function rect_round(context_in, x, y, width, height, radius, style, col, alfa)
{
	context_in.beginPath();
	context_in.moveTo(x + radius, y);
	context_in.lineTo(x + width - radius, y);
	context_in.quadraticCurveTo(x + width, y, x + width, y + radius);
	context_in.lineTo(x + width, y + height - radius);
	context_in.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
	context_in.lineTo(x + radius, y + height);
	context_in.quadraticCurveTo(x, y + height, x, y + height - radius);
	context_in.lineTo(x, y + radius);
	context_in.quadraticCurveTo(x, y, x + radius, y);
	context_in.closePath();
	context_in.globalAlpha = alfa;

	switch(style & MASK)
	{
		case OUTLINE:
			context_in.strokeStyle = style & GRAD ? col : col.str;
			context_in.stroke();
			break;

		case FILL:			
			context_in.fillStyle = style & GRAD ? col : col.str;
			context_in.fill();
			break;
	}
}

function RGB(r,g,b)
{
	this.r = r;
	this.g = g;
	this.b = b;
	this.str = 'rgb(' + r + ',' + g + ',' + b + ')';
	return this;
}

function RGB2INT(col)
{
    return parseInt(col.substr(1,6), 16);
}

function measure_text(context, text, font)
{
	context.font = font;
	var res = context.measureText(text);
	return res.width;
}

function draw_text(context, x, y, text, font, col, alfa)
{
	context.globalAlpha = alfa;
	context.fillStyle = col.str;
	context.font = font;
	context.fillText(text, x, y);
}

function triangle(context_in, x1, y1, x2, y2, x3, y3, col, alfa)
{
	context_in.beginPath();
	context_in.moveTo(x1, y1);
	context_in.lineTo(x2, y2);
	context_in.lineTo(x3, y3);
	context_in.lineTo(x1, y1);
	context_in.strokeStyle = col.str;
	context_in.lineWidth = 1;
	context_in.globalAlpha = alfa;
	context_in.closePath();
	context_in.fillStyle = col.str;
//        context.fillStyle = pattern_chess;
	//context.stroke();
 	context_in.fill();
}

function line(context, xs, ys, xe, ye, col, alfa, line_size)
{
//	line_size = typeof line_size_in != "number" ? 2 : line_size_in;
	context.beginPath();
	context.moveTo(xs, ys);
	context.lineTo(xe, ye);
	context.lineWidth = line_size;
	context.strokeStyle = col.str;
	context.globalAlpha = alfa;
	context.stroke();
}

function triangle(context, x1, y1, x2, y2, x3, y3, col, alfa)
{
	context.beginPath();
	context.moveTo(x1, y1);
	context.lineTo(x2, y2);
	context.lineTo(x3, y3);
	context.lineTo(x1, y1);
	context.strokeStyle = col.str;
	context.lineWidth = 1;
	context.globalAlpha = alfa;
	context.closePath();
	context.fillStyle = col.str;
 	context.fill();
}

function measure_text(context, text, font)
{
	context.font = font;
	var res = context.measureText(text);
	return res.width;
}

function draw_text(context, x, y, text, font, col, alfa)
{
	context.globalAlpha = alfa;
	context.fillStyle = col.str;
	context.font = font;
	context.fillText(text, x, y);
}

var LINEAR = 1;

function create_gradient(context_in,type, x1, y1, x2, y2, col_start, col_end) //, alfa_s, alfa_e)
{
	var gradient;

	switch (type)
	{
		case LINEAR:
			gradient = context_in.createLinearGradient(x1, y1, x2, y2);
			gradient.addColorStop(0, col_start.str);
			gradient.addColorStop(1, col_end.str);
			break;
	}
	return gradient;
}

function create_gradient3(context_in,type, x1, y1, x2, y2, x3, y3, col_start, col_mid, col_end) //, alfa_s, alfa_e)
{
	var gradient;

	switch (type)
	{
		case LINEAR:
			gradient = context_in.createLinearGradient(x1, y1, x3, y3);
			gradient.addColorStop(0, col_start.str);
			gradient.addColorStop(0.5, col_mid.str);
			gradient.addColorStop(1, col_end.str);
			break;
	}
	return gradient;
}

var col_black = new RGB(0,0,0);
var col_white = new RGB(255,255,255);
var col_gray = new RGB(128,128,128);
var col_gray_lite = new RGB(192,192,192);


// --------------

var addEvent = function(elem, type, eventHandle) {
    if (elem == null || elem == undefined) return;
    if ( elem.addEventListener ) {
        elem.addEventListener( type, eventHandle, false );
    } else if ( elem.attachEvent ) {
        elem.attachEvent( "on" + type, eventHandle );
    } else {
        elem["on"+type]=eventHandle;
    }
};

// ----- event/mouse

var doc_mouse_down = 0;

var MOUSE_DOWN = 0;
var MOUSE_UP = 1;
var MOUSE_MOVE = 2;
var MOUSE_WHEEL = 3;

var page_mouse_callbacks = new Array();
var page_mouse_callbacks_num = 0;

var page_locked = 1;

// callback: event, mx, my, buttons

function getPosition(element) // absolute position of element
{
    var xPosition = 0;
    var yPosition = 0;
  
    while(element) {
        //xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        //yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        xPosition += (element.offsetLeft + element.clientLeft);
        yPosition += (element.offsetTop + element.clientTop);
        element = element.offsetParent;
    }
    return { x: xPosition, y: yPosition };
}

function page_mouse_callback_register(callback)
{
	page_mouse_callbacks.push(callback);
	page_mouse_callbacks_num = page_mouse_callbacks.length;
}

function page_mouse_callbacks_call(ev, mx, my, btn, whl)
{
	if (page_locked) return;
	var a;
	for (a = 0; a < page_mouse_callbacks_num; a++)
	{
		var cb = page_mouse_callbacks[a];
		cb(ev, mx, my, btn, whl);
	}
}

function page_mouse_down(e)
{
	page_mouse_callbacks_call(MOUSE_DOWN, e.pageX, e.pageY, 1, 0);
	//e.preventDefault();
}

function page_mouse_up(e)
{
	page_mouse_callbacks_call(MOUSE_UP, e.pageX, e.pageY, 1, 0);
	e.preventDefault();
}

function page_mouse_move(e)
{
	page_mouse_callbacks_call(MOUSE_MOVE, e.pageX, e.pageY, 0, 0);
	e.preventDefault();
}

function page_mouse_wheel(e)
{
	var delta = 0;
	if (!event) /* For IE. */
		event = window.event;
	if (event.wheelDelta) { /* IE/Opera. */
		delta = event.wheelDelta/120;
	} else if (event.detail) { /** Mozilla case. */
                		/** In Mozilla, sign of delta is different than in IE.
                 		* Also, delta is multiple of 3.
                 		*/
		delta = -event.detail/2;
	}
	if (delta)
 	{
 		page_mouse_callbacks_call(MOUSE_WHEEL, e.pageX, e.pageY, 0, delta);
 	}
 	e.preventDefault();
}

if (typeof dev_pflab !== "undefined")
{
	document.onmousemove	= page_mouse_move;
	document.onmousedown	= page_mouse_down;
	document.onmouseup   	= page_mouse_up;
	//document.onmousewheel	= page_mouse_wheel;
}

function page_lock(l)
{
	page_locked = l;
}

function div_resize(id, x, y, wid, hei)
{
	var div = document.getElementById(id);

	if (div)
	{
		div.style.left = x+"px";
		div.style.top = y+"px";
		div.style.width = wid+"px";
		div.style.height = hei+"px";
	}
		div.style.visibility = "visible";
		div.style.display = "";
}